<div class="d-flex flex-row g-12 align-items-center justify-content-between w-100">

    <div class="dmg-size-presentation">
        <span class="d-flex g-8" *ngIf="czyPomieszczenie()">
            Pomieszczenie
            <em class="separator"><img src="assets/images/arrow_separator.svg"></em>
        </span>
        <span>{{ zbiorUszkodzen.opisLokalizacji }}
        </span>
        <span class="d-flex g-8" *ngIf="czyLokalizacjaZWymiaramiPomieszczenia()">
            <em class="separator"><img src="assets/images/arrow_separator.svg"></em>
            {{ this.zbiorUszkodzen.parametry.szerokoscPomieszczenia | number:'':language }}m <span>x</span>
            {{ this.zbiorUszkodzen.parametry.dlugoscPomieszczenia | number:'':language }}m <span>x</span>
            {{ this.zbiorUszkodzen.parametry.wysokoscPomieszczenia | number:'':language }}m
        </span>
    </div>

    <div class="d-flex flex-row">
        <div class="d-flex flex-row g-8 align-items-center">
            <em class="icon" (click)="edytujZbiorUszkodzen()" title="Edytuj">
                <img src="assets/images/pen.png" alt="Edytuj">
            </em>
            <em class="icon" (click)="usunZbiorUszkodzen({zbiorUszkodzenPrzedmiotowId: zbiorUszkodzenPrzedmiotuId, zbiorUszkodzenId: zbiorUszkodzen.id})" title="Usuń">
                <img src="assets/images/trash_bin.png" alt="Usuń">
            </em>
        </div>

    </div>
</div>
